import { AudioManager } from '../../../core/AudioManager';
import { AudioHandle, PositionalOptions } from '../../../core/AudioManager.types';
import { Character } from '../../Character';

export class WalkAudio {
    static readonly PRELOAD = ['../assets/sounds/walk.mp3'] as const;
    private static readonly SRC = WalkAudio.PRELOAD[0];
    private static readonly OPTIONS: PositionalOptions = { volume: 0.8, loop: true, refDistance: 1 };

    private handle: AudioHandle | null = null;

    constructor(
        private readonly audioManager: AudioManager,
        private readonly character: Character,
    ) {}

    public play(): void {
        if (this.handle) { return; }
        this.handle = this.audioManager.playPositional(WalkAudio.SRC, this.character, WalkAudio.OPTIONS);
    }

    public stop(): void {
        if (!this.handle) { return; }
        this.audioManager.stopPositional(this.handle);
        this.handle = null;
    }
}
